import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=4b5b78c4"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=4b5b78c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports